const STUDENT_PERMISSION_KEYS = [
  "VIEW_SELF_STUDENT_PROFILE",
  "VIEW_SELF_STUDENT_FEES",
  "VIEW_SELF_STUDENT_COURSES",
  "VIEW_SELF_STUDENT_CATALOG",
];

export function hasStudentPortalPermission(permissionList) {
  if (!Array.isArray(permissionList) || permissionList.length === 0) return false;
  const normalized = permissionList.map((p) => String(p).trim().toUpperCase());
  return STUDENT_PERMISSION_KEYS.some((key) => normalized.includes(key));
}

/**
 * True when the logged-in org user is an EMS student portal account.
 */
export function isStudentUser(userData, permissionList = null) {
  if (!userData) return false;

  const roleName =
    userData?.role_name ||
    userData?.role?.user_role_name ||
    userData?.RoleAssignment?.ApplicationUserRole?.user_role_name ||
    "";
  if (String(roleName).trim().toLowerCase() === "student") {
    return true;
  }

  const typeName =
    userData?.organizationuser?.UserTypes?.user_type_name ||
    userData?.organizationuser?.user_types?.user_type_name ||
    userData?.organizationuser?.UserTypes?.user_type_code ||
    "";

  if (String(typeName).trim().toLowerCase() === "student") {
    return true;
  }

  const loginuser = Array.isArray(userData?.loginuser)
    ? userData.loginuser[0]
    : userData?.loginuser;

  if (Boolean(loginuser?.organization_ems_student_id)) {
    return true;
  }

  return hasStudentPortalPermission(permissionList);
}

export function getStudentHomePath() {
  return "/student/dashboard";
}
